import allProducts from './products/data/all.json';
import latestProducts from './products/data/latest.json';

export {
  latestProducts
}

export default allProducts;
